import { useEffect, useState } from "react";

export const clockNow = (): number =>
  typeof globalThis.performance?.now === "function"
    ? globalThis.performance.now()
    : Date.now();

/**
 * Re-renders every animation frame until `until` (a clockNow timestamp), then
 * stops. With `coarse` (reduced motion) it skips the frames and wakes once at
 * the end, for state that simply appears and goes.
 */
export function useFrameClock(until: number, coarse: boolean): number {
  const [now, setNow] = useState(clockNow);
  useEffect(() => {
    if (clockNow() >= until) return undefined;
    if (coarse) {
      const id = setTimeout(() => setNow(clockNow()), until - clockNow() + 1);
      return () => clearTimeout(id);
    }
    let raf = 0;
    const tick = () => {
      const t = clockNow();
      setNow(t);
      if (t < until) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [until, coarse]);
  return now;
}
